export type MicrositeFeatureFlags = {
  readonly serviceReviewSchemaEnabled: boolean;
};

export const defaultMicrositeFeatureFlags: MicrositeFeatureFlags = {
  serviceReviewSchemaEnabled: false,
};
